//第一次初始化数据
export const CLIENT_INIT_DATUM = "client init datum";
//客户列表页数变化
export const CLIENT_PAGINATION_VARIATION = "client pagination variation"
export const CLIENT_PAGINATION_VARIATION_THERE_ARE_DATA = "client pagination variation there are data"
//修改请求参数内容
export const CLIENT_REQUSET_PARAM  = "client requset param"

//重置内容
export const CLIENT_RESET_CONTENT = "client reset content"
//条件改变重新拉去新数据
export const CLIENT_CONDITION_VARIATION = "client condition variation"

//员工转移更改列表数据
export const CLIENT_TRANSFER = "client transfer"



// WEBPACK FOOTER //
// ./src/vuex/client/type.js